export const BOOKING_HORIZON_MIN = 7;

// The webapp bundles this module through the browser barrel, where `process`
// does not exist — reading env under a typeof guard keeps the test-scenario
// override server-only instead of forcing a second copy of the ceiling.
const env: Record<string, string | undefined> =
  typeof process !== 'undefined' && process.env ? process.env : {};

const TEST_SCENARIO_MODE = env.TEST_SCENARIO_MODE === '1';
const parsedTestMax = Number(env.TEST_BOOKING_HORIZON_MAX);
const hasTestMax = Number.isFinite(parsedTestMax);
const TEST_HORIZON_MAX = hasTestMax ? Math.max(BOOKING_HORIZON_MIN, Math.round(parsedTestMax)) : null;

export const BOOKING_HORIZON_MAX = TEST_SCENARIO_MODE && TEST_HORIZON_MAX ? TEST_HORIZON_MAX : 90;
export const BOOKING_HORIZON_DEFAULT = 30;
